
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {Ihbarname89_1Talep, Ihbarname89_2Talep, Ihbarname89_3Talep,} from "@/interface/IUyapTalep";
import UyapAdliyePicker from "@/components/pickers/uyap/UyapAdliyePicker.vue";
import UcuncuSahisPicker from "@/components/pickers/uyap/UcuncuSahisPicker.vue";
import Dates from "@/components/inputs/Dates.vue";
import AvukatTalepTebligatTuruPicker from "@/components/pickers/uyap/AvukatTalepTebligatTuruPicker.vue";
import AvukatTalepAdresTuruPicker, {
  AvukatTalepAdresTuru
} from "@/components/pickers/uyap/AvukatTalepAdresTuruPicker.vue";
import TarafListPicker from "@/components/pickers/uyap/TarafListPicker.vue";
import {UyapHacizEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapHacizEvrakTuru";
import DosyaAraciKisiKurumTarafListesiPicker from "@/components/pickers/uyap/DosyaAraciKisiKurumTarafListesiPicker.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import UcuncuTarafForm from "@/components/forms/form-wizard/eicrapro/UcuncuTarafForm.vue";

@Component({
  computed: {
    AvukatTalepAdresTuru: () => AvukatTalepAdresTuru
  },
  components: {
    UcuncuTarafForm,
    FormDialog,
    DosyaAraciKisiKurumTarafListesiPicker,
    TarafListPicker,
    AvukatTalepAdresTuruPicker, AvukatTalepTebligatTuruPicker, Dates, UcuncuSahisPicker, UyapAdliyePicker
  }
})
export default class IhbarnameTalepEvrakForm extends Mixins(ObjectInputMixin) {
  @Prop() dosyaId!: string;
  @Prop() tckn!: string;
  @Prop() vergiNo!: string;
  @Prop() borcluKisiKurumId!: number;
  @Prop() talepKodu!: number;
  @Prop() varsayilan!: string | boolean;
  @Prop({default: () => []}) secilenTakipler!: Array<any>;

  localValue!: any;
  uyapHacizEvrakTuru = UyapHacizEvrakTuru;
  kisiMi!: boolean;
  tarafFormData: any = {};
  alertGenisletildi = false;

  sorguProgress: boolean = false;

  varsayilanKisiHeaders = [
    {text: 'Kişi', value: 'tarafAdi'},
    {text: 'Dosyalar', value: 'dosyalar', width: '50%'},
    {text: 'Kaldır', value: 'kaldir', sortable: false, width: '80px'}
  ];

  get dosyaItems() {
    return this.secilenTakipler.map((takip: any) => ({
      dosyaNo: takip.dosyaNo + ' - ' + takip.birimAdi,
      dosyaId: takip.dosyaId || takip.task?.response?.dosya?.dosyaId
    }));
  }

  get bosDosyaItems() {
    const assignedIds = (this.localValue.kisiler || []).flatMap((k: any) => k.dosyalar || []);
    return this.dosyaItems.filter((d: any) => !assignedIds.includes(d.dosyaId));
  }

  get bosDosyaSayisi() {
    return this.bosDosyaItems.length;
  }

  get baziDosyalarBos() {
    return this.bosDosyaSayisi > 0 && this.bosDosyaSayisi < this.dosyaItems.length;
  }

  getAvailableDosyaItemsForKisi(kisi: any) {
    return this.dosyaItems.filter((d: any) => {
      const assignedToOther = (this.localValue.kisiler || []).some(
        (k: any) => k !== kisi && k.dosyalar && k.dosyalar.includes(d.dosyaId)
      );
      return !assignedToOther;
    });
  }

  onTarafEklendi(tarafData: any) {
    if (!this.localValue.kisiler) {
      this.$set(this.localValue, 'kisiler', []);
    }
    const assignedDosyaIds = (this.localValue.kisiler || []).flatMap((k: any) => k.dosyalar || []);
    const availableDosyaIds = this.dosyaItems
      .map((d: any) => d.dosyaId)
      .filter((id: string) => !assignedDosyaIds.includes(id));
    this.localValue.kisiler.push({
      ...tarafData,
      dosyalar: availableDosyaIds
    });
    this.tarafFormData = {};
    this.input();
  }

  kisiKaldir(index: number) {
    this.localValue.kisiler.splice(index, 1);
    this.input();
  }

  get adresRule() {
    if (this.localValue.adresTuru == AvukatTalepAdresTuru.YENI) {
      if (!this.localValue.adres)
        return 'Lütfen bu alanı doldurun';
      if (this.localValue.adres.length > 1000)
        return 'Maksimum 1000 karakter kullanılabilir';
    }
    return true;
  }

  get isVarsayilan() {
    return this.varsayilan || this.varsayilan === "";
  }

  @Watch('localValue.adresTuru')
  onAdresTuruChange() {
    if (this.localValue.adresTuru == AvukatTalepAdresTuru.MERNIS || this.localValue.adresTuru == AvukatTalepAdresTuru.MERSIS)
      this.adresSorgula();
  }

  // TODO: sorgular artık getIcraTebligatTalebiAdresSorgula yapılıyor hata durumunda bunu kullan
  async adresSorgula() {
    this.sorguProgress = true;
    // mernis 1 mersis 2
    if (this.localValue.adresTuru == AvukatTalepAdresTuru.MERNIS && this.tckn) {
      let mernisRes = await this.$uyap.KisiMernisAdresiVarmi().run({tcKimlikNo: this.tckn});
      this.localValue.adres = mernisRes ? 'VAR' : 'YOK';
    } else if (this.localValue.adresTuru == AvukatTalepAdresTuru.MERSIS && this.vergiNo) {
      let mersisRes = await this.$uyap.GetKurumMersisAdresi().run({vergiNo: this.vergiNo, mersisNo: ''});
      this.localValue.adres = !!mersisRes ? 'VAR' : 'YOK';
    } else if (this.localValue.adresTuru == AvukatTalepAdresTuru.E_TEBLIGAT) {
      let etebligatRes = await this.$uyap.GetIcraTebligatTalebiAdresSorgula().run({
        dosyaId: this.dosyaId,
        kisiKurumId: this.borcluKisiKurumId,
        kayitId: this.localValue.kisiKurumId,
        adresTuru: "ADRTR00013"
      });
      this.localValue.adres = etebligatRes.adres;
    }
    setTimeout(() => {
      this.sorguProgress = false
    }, 2000)
  }
}
